import { gql } from '@/shared/graphql/generated/explorer';

export const getDepositsForSpecificLiquidityDepositChannelQuery = gql(/* GraphQL */ `
  query getDepositsForSpecificLiquidityDepositChannel(
    $channelId: BigInt
    $chain: ChainflipChain
    $issuedBlockId: Int
  ) {
    channels: allLiquidityDepositChannels(
      condition: { channelId: $channelId, chain: $chain, issuedBlockId: $issuedBlockId }
      orderBy: ID_DESC
      first: 1
    ) {
      nodes {
        id
        asset
        chain
        channelId
        deposits: liquidityDepositsByLiquidityDepositChannelId {
          nodes {
            depositAmount
            event: eventByEventId {
              blockId
              indexInBlock
            }
            effectiveBoostFeeBps
          }
        }
        depositAddress
      }
    }
  }
`);
